module.exports = __webpack_public_path__ + "static/1272269821-wide.9145ac7d.jpg";